import React from "react";
import { Alert, Table } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import apiCall from "../../api/api-call";

function ApplicantTable({ applicants }) {
  const handleFileDownload = (fileLocation) => {
    //console.log("click to download: ", fileLocation);

    apiCall
      .getPresignedUrl(fileLocation)
      .then((response) => {
        //console.log("getPresignedUrl response: ", response);
        window.open(response.data.signedUrl, "_blank");
      })
      .catch((error) => {
        console.log("getPresignedUrl error: ", error);
      });
  };

  const handlePanel = (elem, applyid) => {
    //console.log("applyid: ", applyid);
    const selectedPanel = document.getElementById(`panel-${applyid}`);
    let arrowElem = elem.nodeName === "I" ? elem : elem.children[0];

    //console.log("elem: ", elem);

    if (selectedPanel.classList.contains("d-none")) {
      selectedPanel.classList.remove("d-none");
      arrowElem.classList.remove("fa-chevron-down");
      arrowElem.classList.add("fa-chevron-up");
    } else {
      selectedPanel.classList.add("d-none");
      arrowElem.classList.add("fa-chevron-down");
      arrowElem.classList.remove("fa-chevron-up");
    }
  };

  return (
    <div className="mb-0">
      <div className="border-bottom pb-2 mb-0">
        <h6>List of Applicants</h6>
      </div>
      {applicants && applicants.length ? (
        <>
          <Table striped bordered responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Portfolio</th>
                <th>Job Title</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {applicants.map((applicant, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td>{index + 1}</td>
                    <td style={style.applicantNameCol}>{applicant.name}</td>
                    <td style={style.emailNameCol}>
                      <a href={`mailto:${applicant.email}`}>
                        {applicant.email}
                      </a>
                    </td>
                    <td>{applicant.website ? applicant.website : "N/A"}</td>
                    <td>
                      <NavLink to={`/job-detail/${applicant.jobId}`}>
                        {applicant.jobTitle}
                      </NavLink>
                    </td>
                    <td style={style.fileDownloadCol}>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() =>
                          handleFileDownload(applicant.fileUploadLocation)
                        }
                      >
                        <i className="fa fa-download" aria-hidden="true"></i>{" "}
                        File
                      </button>
                    </td>
                    <td style={style.panelCol}>
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={(e) =>
                          handlePanel(e.target, applicant.applyid)
                        }
                      >
                        <i className="fas fa-chevron-down"></i>
                      </button>
                    </td>
                  </tr>
                  <tr
                    className="d-none more-panel"
                    id={`panel-${applicant.applyid}`}
                  >
                    <td colSpan={7}>
                      <div className="p-3">
                        <h6>Cover Letter</h6>
                        <pre style={{ whiteSpace: "pre-wrap" }}>
                          {applicant.coverLetter
                            ? applicant.coverLetter
                            : "N/A"}
                        </pre>
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        <Alert variant={`secondary`}>No applicants available.</Alert>
      )}
    </div>
  );
}

const style = {
  applicantNameCol: { width: "20%" },
  emailNameCol: { width: "10%" },
  fileDownloadCol: { width: "80px" },
  panelCol: { width: "20px" },
};

export default ApplicantTable;
